/**
 * Helper functions for TaskList component logic
 */

/**
 * Determines the locationKeys array for loadColumnFilters based on search parameters
 * @param {Object} searchParams - The search parameters object
 * @param {string|null} defaultLocationKey - The default location key to fall back to
 * @returns {string[]} Array of location keys to use for filtering
 */
export const determineLocationKeysForFilters = (searchParams, defaultLocationKey) => {
    // Properly handle boolean values from URL parameters (strings vs booleans)
    const isAllLocations = searchParams?.allLocations === true || searchParams?.allLocations === 'true';
    
    let locationKeys = Array.isArray(searchParams?.locationKeys) 
        ? searchParams.locationKeys 
        : [];

    // If not in "all locations" mode and no location keys selected, fall back to default
    if (!isAllLocations && locationKeys.length === 0) {
        locationKeys = defaultLocationKey ? [defaultLocationKey] : [];
    }

    // When in "all locations" mode, return empty array (loads all locations)
    if (isAllLocations) {
        locationKeys = [];
    }

    return locationKeys;
};